import { FieldValues } from "react-hook-form";

import { BaseFormInputPropsType, VnFormInput } from "../VnForm";
import {
  BaseOTPInput,
  BaseOTPInputGroup,
  BaseOTPInputSlot,
} from "./BaseOTPInput";

type VnOTPInputPropsType<T extends FieldValues> = BaseFormInputPropsType<T> & {
  inputClassName?: string;
  otpLength?: number;
  onComplete?: (otp: string) => void;
};

export const VnOTPInput = <T extends FieldValues>({
  inputClassName,
  otpLength = 6,
  isDisabled,
  ...props
}: VnOTPInputPropsType<T>) => {
  return (
    <VnFormInput isDisabled={isDisabled} {...props}>
      {({ field }) => (
        <BaseOTPInput
          maxLength={otpLength}
          className={inputClassName}
          disabled={isDisabled}
          {...props}
          {...field}
          render={({ slots }) => (
            <BaseOTPInputGroup>
              {slots.map((slot, idx) => (
                <BaseOTPInputSlot
                  key={idx}
                  className={inputClassName}
                  {...slot}
                />
              ))}
            </BaseOTPInputGroup>
          )}
        />
      )}
    </VnFormInput>
  );
};
